/**
 * Web App Config Context
 * Provides config from API with built-in defaults. Regression-proof when API unavailable.
 */

import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  fetchWebAppConfig,
  DEFAULT_CONFIG,
  WebAppConfig,
  ViewType,
} from '../services/webAppConfig';

const WebAppConfigContext = createContext<{
  config: WebAppConfig;
  configLoaded: boolean;
}>({ config: DEFAULT_CONFIG, configLoaded: false });

export function WebAppConfigProvider({ children }: { children: React.ReactNode }) {
  const [config, setConfig] = useState<WebAppConfig>(DEFAULT_CONFIG);
  const [configLoaded, setConfigLoaded] = useState(false);

  useEffect(() => {
    fetchWebAppConfig().then((c) => {
      setConfig(c);
      setConfigLoaded(true);
    });
  }, []);

  return (
    <WebAppConfigContext.Provider value={{ config, configLoaded }}>
      {children}
    </WebAppConfigContext.Provider>
  );
}

export function useWebAppConfig() {
  const ctx = useContext(WebAppConfigContext);
  if (!ctx) {
    return { config: DEFAULT_CONFIG, configLoaded: false };
  }
  return ctx;
}

export type { WebAppConfig, ViewType };
